import { Button } from '@listening/frontend/components/radix/button';
import type { ErrorComponentProps } from '@tanstack/react-router';
import {
  ErrorComponent,
  Link,
  rootRouteId,
  useMatch,
  useRouter,
} from '@tanstack/react-router';
import { localizeHref } from '@/paraglide/runtime';
import { rootLogger } from '@/lib/root-logger';

const moduleLogger = rootLogger.child({ module: 'DefaultCatchBoundary' });

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
  const router = useRouter();
  const isRoot = useMatch({
    strict: false,
    select: (state) => state.id === rootRouteId,
  });

  moduleLogger.error(error);

  return (
    <div className='flex min-w-0 flex-1 flex-col items-center justify-center gap-6 p-4'>
      <ErrorComponent error={error} />
      <div className='flex flex-wrap items-center gap-2'>
        <Button
          className='px-2 py-1 font-extrabold uppercase'
          onClick={() => {
            void router.invalidate();
          }}
        >
          Try Again
        </Button>
        {isRoot ? (
          <Link
            className='px-2 py-1 font-extrabold uppercase'
            to={localizeHref('/')}
          >
            Home
          </Link>
        ) : (
          <Link
            className='px-2 py-1 font-extrabold uppercase'
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault();
              window.history.back();
            }}
            to={localizeHref('/')}
          >
            Go Back
          </Link>
        )}
      </div>
    </div>
  );
}
